<template>
  <b-card-actions
    ref="card"
    title=""
    action-refresh
    @refresh="refresh"
  >

    <b-tabs v-model="tabIndex">
      <b-tab>
        <template #title>
          <feather-icon icon="HomeIcon" />
          <span>  {{ $t('Vehicle') }}
          </span>
        </template>

        <div>
          <!-- Media -->
          <b-media class="mb-2">
            <template #aside>
              <cropper
                v-if="showCropper"
                id="profile_image"
                ref="cropper"
                :src="url"
                class="cropper h-24 w-24"
                :stencil-props="{
                  aspectRatio: 10/10
                }"
              />
              <img
                v-else
                :src="url"
                class="mr-8 rounded h-24 w-24 profile-pic"
              >
            </template>
            <h4 class="mb-1">
              {{ vehicle.manufacturer + ' ' + vehicle.model + ' ' + vehicle.vehicle_id }}
            </h4>
            <div class="d-flex flex-wrap">

              <input
                id="profile_image"
                ref="refInputEl"
                type="file"
                class="hidden"
                accept="image/*"
                name="profile_image"
                @change="selectedFile"
              >

              <b-button
                v-if="!showCropper"
                variant="primary"
                :disabled="allEditDisabled"
                @click="$refs.refInputEl.click()"
              >

                <span class="d-none d-sm-inline">{{ $t('Upload Image') }}</span>
                <feather-icon
                  icon="EditIcon"
                  class="d-inline d-sm-none"
                />
              </b-button>
              <b-button
                v-else
                variant="primary"
                @click="cropImage()"
              >

                <span class="d-none d-sm-inline">{{ $t('Crop') }}</span>
                <feather-icon
                  icon="EditIcon"
                  class="d-inline d-sm-none"
                />
              </b-button>
              <b-button
                variant="outline-secondary"
                class="ml-1"
                :disabled="allEditDisabled"

                @click="deleteImage()"
              >
                <span class="d-none d-sm-inline">{{ $t('Delete') }}</span>
                <feather-icon
                  icon="TrashIcon"
                  class="d-inline d-sm-none"
                />
              </b-button>
            </div>
          </b-media>

          <validation-observer
            ref="validationRules"
            tag="form"
          >
            <b-form>
              <b-row>

                <!-- Field: Manufacturer -->
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label-for="manufacturer"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="manufacturer"
                      rules="required"
                      :custom-messages="customMessages"
                      :state="errors.length > 0 ? false:null"
                    >
                      <label v-html="getRequiredLabel('Manufacturer')" />

                      <b-form-input
                        id="manufacturer"
                        v-model="vehicle.manufacturer"
                        :disabled="allEditDisabled"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>

                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Field: Model -->
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label-for="model"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="model"
                      rules="required"
                      :custom-messages="customMessages"
                    >
                      <label v-html="getRequiredLabel('Model')" />

                      <b-form-input
                        id="model"
                        v-model="vehicle.model"
                        :disabled="allEditDisabled"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>

                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Field: Vehicle ID -->
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    label-for="vehicle_id"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Vehicle ID"
                      rules="required"
                      :custom-messages="customMessages"
                    >
                      <label v-html="getRequiredLabel('Vehicle ID')" />
                      <b-form-input
                        id="plant_id"
                        v-model="vehicle.vehicle_id"
                        :disabled="allEditDisabled"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

              </b-row>
              <b-row>
                <!-- Field: Assigned to -->
                <b-col
                  cols="12"
                  md="12"
                >
                  <b-form-group
                    :label="$t('Assigned to')"
                    label-for="user-role"
                  >
                    <v-select
                      v-model="currentEmployee"
                      :options="sortedEmployees"
                      :reduce="employee => employee.id"
                      label="display_name"
                      :disabled="allEditDisabled"
                      @input="setEmployee"
                    />
                  </b-form-group>
                </b-col>

              </b-row>
              <b-row>
                <!-- Field: Note -->
                <b-col
                  cols="12"
                  md="12"
                >
                  <b-form-group
                    :label="$t('Note')"
                    label-for="note"
                  >
                    <b-form-textarea
                      id="note"
                      v-model="vehicle.note"
                      rows="3"
                      name="note"
                      :disabled="allEditDisabled"
                    />
                  </b-form-group>
                </b-col>
                <!-- Field: Terminated -->
                <b-col
                  cols="12"
                  md="4"
                >
                  <b-form-group
                    :label="$t('Status')"
                    label-for="terminated"
                  >
                    <b-form-checkbox
                      id="terminated"
                      v-model="terminated"
                      name="terminated"
                      switch
                      inline
                      class="mt-06 custom-control-danger"
                      :disabled="allEditDisabled"
                    >
                      {{ terminated_label }}
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>

              </b-row>
            </b-form>
          </validation-observer>

          <!-- Action Buttons -->
          <b-button
            variant="primary"
            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            :disabled="allEditDisabled"
            @click.prevent.stop="handleSubmit()"
          >
            {{ $t('Save') }}
          </b-button>
          <b-button
            variant="outline-secondary"
            type="reset"
            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
            @click.prevent.stop="back($event)"
          >
            {{ $t('Cancel') }}

          </b-button>
        </div>

      </b-tab>
      <b-tab
        ref="documents_tab"
        :disabled="!documents_enabled"
      >
        <template #title>
          <feather-icon icon="BookIcon" />
          <span> {{ $t('Documents') }}</span>
        </template>

        <vehicle-documents-list-component />
      </b-tab>

    </b-tabs>
  </b-card-actions>

</template>

<script>
import {
  BAvatar,
  BButton,
  BCard,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BMedia,
  BRow,
  BTab,
  BTable,
  BTabs,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'

import Ripple from 'vue-ripple-directive'
import useJwt from '@/auth/jwt/useJwt'
import store from '@/store'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { BCardActions } from '@core/components/b-card-actions'
import i18n from '@/libs/i18n'
import Spacer from '@/views/components/spacer/Spacer'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import EquipmentService from '@/basic/equipmentService'
import useUsersList from '@/views/apps/user/users-list/useUsersList'
import { ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import VehicleDocumentsListComponent from '@/views/table/vue-good-table/VehicleDocumentsListComponent'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import ability from '@/libs/acl/ability'
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

// Extend the 'required' rule
extend('required', required)

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BCardText,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BAvatar,
    BCard,
    BFormTextarea,
    BTable,
    BCardHeader,
    BCardTitle,
    BCardActions,
    BMedia,
    BTabs,
    BDropdown,
    BTab,
    BDropdownItem,
    flatPickr,
    Spacer,
    vSelect,
    VehicleDocumentsListComponent,
    BFormFile,
    Cropper,

  },
  directives: {
    Ripple,
  },

  data() {
    return {
      vehicle: {
        manufacturer: '',
        model: '',
        vehicle_id: '',
        model_id: '',
        photo: '',
        note: '',

      },
      customMessages: {
        required: i18n.t('This field is required'),
      },
      errors: [],
      employees: [{ id: 0, first_name: i18n.t('Corporate') }],
      new_employee_id: 0,
      company_users: [],
      userData: JSON.parse(localStorage.getItem('userData')),
      userCompany: JSON.parse(localStorage.getItem('userCompany')),
      editDisabled: false,
      allEditDisabled: !ability.can('manage', 'Basic Equipments'),
      department_new_id: 1,
      role_new_id: 1,
      vehicle_roles: [{ id: 1, name: '' }],
      vehicle_departments: [{ id: 1, name: '' }],
      dateDefault: null,
      assignment_options: ['a', 'b', 'c'],
      assignment_selected: [],
      protected_category: false,
      documents_enabled: false,
      medical_enabled: false,
      avatar_file: null,
      filedata: null,
      images: null,
      url: require('@/assets/images/avatars/vehicle.png'),
      variant: 'light',
      opacity: 0.85,
      blur: '2px',
      crop: {
        src: '',
        type: 'image/jpg',
      },
      file_name: '',
      showCropper: false,
      tab: this.$route.params.tab ? this.$route.params.tab : 'main',
      tabIndex: 1,
      terminated: false,
    }
  },
  computed: {
    currentEmployee() {
      if (this.employees && this.new_employee_id) {
        const employee = this.employees.find(l => l.id == this.new_employee_id)
        console.log('currentEmployee section', employee)
        if (employee) {
          return employee.id
        }
      }
      return 0
    },
    sortedEmployees() {
      if (!this.employees) return []

      // Create a copy of employees array with display_name
      const employeesWithDisplay = this.employees.map(emp => ({
        ...emp,
        display_name: emp.id === 0
          ? i18n.t("Corporate")
          : `${emp.last_name} ${emp.first_name}`
      }))

      // Sort: Corporate first, then alphabetically by last_name
      return employeesWithDisplay.sort((a, b) => {
        if (a.id === 0) return -1
        if (b.id === 0) return 1
        return (a.last_name || '').localeCompare(b.last_name || '')
      })
    },
    terminated_label() {
      return (this.terminated) ? i18n.t('Terminated') : i18n.t('Not terminated')
    },
  },
  mounted() {
    this.refresh()
  },
  methods: {
    refresh() {
      console.log('tab', this.tab)
      switch (this.tab) {
        case 'main':
          this.tabIndex = 1
          break
        case 'vehicle_documents':
          this.tabIndex = 2
          break
        default:
          this.tabIndex = 1
          break
      }

      console.log('tabIndex', this.tabIndex)

      const equipmentService = new EquipmentService(useJwt)

      const vehicle_id = this.$route.params.id
      this.$refs.card.showLoading = true

      const company_id = store.state.userCompany.id
      if (vehicle_id !== 'new1') {
        equipmentService.vehicle(vehicle_id, company_id).then(response => {
          if (response.data.data.vehicle) {
            console.log('vehicle', response.data.data.vehicle)
            this.vehicle = response.data.data.vehicle
            console.log('vehicle', this.vehicle)
            if (this.vehicle.photo) this.url = this.vehicle.photo
            this.documents_enabled = true

            this.employees = response.data.data.employees
            // put an element with id = 0 and First name = Aziendale in head of this.employees
            this.employees.unshift({ id: 0, first_name: i18n.t('Corporate') })
            console.log('employees', this.employees)
            this.new_employee_id = this.vehicle.employee_id ? this.vehicle.employee_id : 0

            if (this.vehicle.terminated_at) {
              this.terminated = true
            }
          } else {
            console.log('vehicle not found')
          }

          console.log('tabIndex s', this.tabIndex)

          console.log('data', response.data.data)
          console.log('vehicle_roles', this.vehicle_roles)
          this.$refs.card.showLoading = false
        })
      } else {
        this.$refs.card.showLoading = false
      }
    },
    async back(e) {
      this.$router.push({ name: 'vehicles' })
    },
    setEmployee(employeeId) {
      this.new_employee_id = employeeId
      this.vehicle.employee_id = this.new_employee_id
    },
    selectedFile(event) {
      this.success = ''
      this.error = ''
      const filePath = event.target.files[0].name
      const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i
      if (!allowedExtensions.exec(filePath)) {
        this.error = this.$t('FileUploadError')
        this.$toasted.show(this.error, {
          className: 'top-alert',
          position: 'top-center',
          type: 'error',
          duration: 2000,
        })
        $('#profile_image').val('')
      } else {
        this.images = event.target.files[0]
        this.file_name = this.images.name
        this.url = URL.createObjectURL(this.images)
        this.crop.src = URL.createObjectURL(this.images)
        this.showCropper = true
      }
    },

    handleUpload() {
      const filevalue = this.avatar_file
      console.log('handleUpload filevalue', filevalue)

      const filePath = filevalue.name
      console.log('handleUpload filePath', filevalue.name)

      const reader = new FileReader()

      reader.onload = e => {
        console.log('readAsDataURL', e.target.result)
        this.filedata = e.target.result
        const data_upload = {
          filedata: this.filedata,
          filename: filePath,
        }
        console.log('UPLOAD 2', filedata)

        this.vehicle.photo = filedata
      }

      reader.readAsDataURL(this.avatar_file)
    },
    getRequiredLabel(field) {
      return `<span class="text-danger">*</span> ${i18n.t(field)}`
    },
    cropImage() {
      const result = this.$refs.cropper.getResult()
      const obj = this
      this.url = result.canvas.toDataURL(this.crop.type)
      console.log('url', this.url)
      this.urltoFile(
        result.canvas.toDataURL(this.crop.type),
        this.file_name,
        'image/*',
      ).then(file => {
        console.log('rahul--', file)
        obj.images = file
      })
      this.images = obj.images
      this.showCropper = false
    },

    deleteImage() {
      console.log('deleteImage')
      this.images = ''
      this.showCropper = false
      this.url = require('@/assets/images/avatars/avatar.png')
    },

    urltoFile(url, filename, mimeType) {
      return fetch(url)
        .then(res => res.arrayBuffer())
        .then(buf => new File([buf], filename, { type: mimeType }))
    },

    async handleSubmit(e) {
      this.$refs.validationRules.validate().then(success => {
        if (success) {
          console.log('VALIDATION OK')

          const equipmentService = new EquipmentService(useJwt)
          console.log('inputImageRenderer', this.inputImageRenderer)
          this.submitted = true
          // const valid = await this.$validator.validate();
          const valid = true

          if (!valid) {
            this.$vs.notify({
              title: this.$t('create_admin.FailedToCreateAdmin'),
              text: this.$t('create_admin.ConfirmPasswordFailed'),
              color: 'danger',
              position: 'top-center',
            })
            this.submitted = false
            return false
          }

          this.$refs.card.showLoading = true
          this.vehicle.protected_category = this.protected_category
          this.vehicle.photo = this.url
          const data = {
            vehicle: this.vehicle,
            company: this.userCompany,
            photo_file_name: this.file_name,
            terminated: this.terminated,
          }

          try {
            console.log('data', data)
            const vehicle_id = this.$route.params.id

            equipmentService.update_vehicle(vehicle_id, data).then(response => {
              console.log('response', response)
              //          this.refresh();
              this.$refs.card.showLoading = false
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: i18n.t('Vehicle'),
                  icon: 'AlertIcon',
                  variant: 'success',
                  text: i18n.t('Vehicle saved with success'),
                },
              })
              this.$router.push({ name: 'vehicle', params: { id: response.data.data.vehicle.id, tab: 'main' } })
            })

            const response = { status: 200, data: { id: 1 } }
          } catch (error) {

          }
          this.submitted = true
        } else {
          console.log('VALIDATION KO')

          this.submitted = false
        }
      })
    },

  },
  setup(props) {
    const { resolveUserRoleVariant } = useUsersList()
    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null)
    const previewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => {
      // eslint-disable-next-line no-param-reassign
      props.avatar = base64
      console.log('avatar', props.avatar)
    })

    return {
      resolveUserRoleVariant,
      avatarText,

      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
